// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import GlobalController from "./global_controller"
application.register("global", GlobalController)

import LucideController from "./lucide_controller"
application.register("lucide", LucideController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MetadataController from "./metadata_controller"
application.register("metadata", MetadataController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PaneStackController from "./pane_stack_controller"
application.register("pane-stack", PaneStackController)

import PopoutController from "./popout_controller"
application.register("popout", PopoutController)

import ResetFormController from "./reset-form_controller"
application.register("reset-form", ResetFormController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)

import WaiterController from "./waiter_controller"
application.register("waiter", WaiterController)

import WiterEditorController from "./witer_editor_controller"
application.register("witer-editor", WiterEditorController)

import ZettelListController from "./zettel_list_controller"
application.register("zettel-list", ZettelListController)
